import { getAuthenticatedSupabaseClient } from '@/integrations/supabase/client';
import { Panel } from '@/types/Panel';

export const panelServiceAdapter = {
  async getByFloorPlan(floorPlanId: string): Promise<Panel[]> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { data, error } = await supabase
      .from('panels')
      .select('*')
      .eq('floor_plan_id', floorPlanId)
      .order('created_at', { ascending: true });

    if (error) throw error;
    return (data || []) as any;
  },

  async create(item: Partial<Panel>): Promise<Panel> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { data, error } = await supabase
      .from('panels')
      .insert(item as any)
      .select()
      .single();

    if (error) throw error;
    return data as any;
  },

  async update(id: string, updates: Partial<Panel>): Promise<Panel> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { data, error } = await supabase
      .from('panels')
      .update(updates as any)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data as any;
  },

  async delete(id: string): Promise<boolean> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { error } = await supabase
      .from('panels')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return true;
  },
}; 
